import * as z from 'zod';
import type { ZodOpenApiPathsObject } from 'zod-openapi';
import { problemResponse } from './common.js';

export const API_VERSION = 'v1';

export const HealthSchema = z.object({ status: z.literal('ok') }).meta({ id: 'Health' });

export const ReadySchema = z
  .object({
    status: z.enum(['ready', 'not_ready']),
    checks: z.object({ database: z.boolean(), migrations: z.boolean() }),
  })
  .meta({ id: 'Ready' });

/**
 * What this DeliCRM build supports. The Woo plugin reads it and enables only matching
 * features, so the CRM and the plugin can be deployed in any order (plan §3 rule 4).
 */
export const MetaSchema = z
  .object({
    apiVersion: z.literal(API_VERSION),
    build: z.string().meta({ description: 'Release tag or commit SHA' }),
    capabilities: z.array(z.string()),
  })
  .meta({ id: 'Meta' });

export type Health = z.infer<typeof HealthSchema>;
export type Ready = z.infer<typeof ReadySchema>;
export type Meta = z.infer<typeof MetaSchema>;

const json = <T extends z.ZodType>(schema: T) => ({ 'application/json': { schema } });

export const systemPaths: ZodOpenApiPathsObject = {
  '/health': {
    get: {
      summary: 'Process is up',
      responses: { '200': { description: 'OK', content: json(HealthSchema) } },
    },
  },
  '/ready': {
    get: {
      summary: 'Dependencies reachable and migrations applied',
      responses: {
        '200': { description: 'Ready', content: json(ReadySchema) },
        '503': { description: 'Not ready', content: json(ReadySchema) },
      },
    },
  },
  '/api/v1/meta': {
    get: {
      summary: 'API version and capabilities',
      responses: {
        '200': { description: 'OK', content: json(MetaSchema) },
        '500': problemResponse('Unexpected error'),
      },
    },
  },
};
